import React from "react";
import Loader from 'react-loader-spinner'
import FormViewer from "../../components/FormViewer";
import GlobalUserInput from "../../components/inputs/GlobalUserInput";
import MultiSelectInput from "../../components/inputs/MultiSelectInput";
import StatusIndicator from "../../components/inputs/StatusIndicator";
import UserIndicator from "../../components/inputs/UserIndicator";
import LoaderButton from "../../components/LoaderButton";
import TabelGlobalUserInput from "../../components/tableComponents/TabelGlobalUserInput";
import HttpServices from "../../utils/Http.services";
import { checkTranslation, translate } from "../../utils/useful";
import ButtonAnimated from "../../components/buttons/ButtonAnimated";


class AddUserForm extends React.Component {
  state = {
    // isLoadingRemove: false,
    // id: null,
    // index: null,
    // image: '',

    actions: {
      submit: { key: "submit", label: "{{lang}}submit", bgColor: '#677dc4', color: '#fff', function: "submitForm", loader: "isPostingData" },
      cancel: { key: "cancel", label: "{{lang}}cancel", bgColor: '#9ab', color: '#fff', function: "hideModal" },

    }

  }

  // images=["001-man.svg",'011-woman.svg','012-woman.svg','019-man.svg','022-man.svg','025-man.svg','027-woman.svg','033-woman.svg','035-man.svg','038-man.svg','042-man.svg','043-woman.svg','049-woman.svg','050-woman.svg']

  componentDidMount() {
    // this.changeImage()
    //  this.interval = setInterval(() => {
    //   this.changeImage()
    // }, 1500);
  }


  componentWillUnmount() {
    clearInterval(this.interval)
  }

  changeImage = () => {
    let number = Math.floor(Math.random() * this.images.length - 1)
    if (this.images[number]) {
      let image = this.images[number]
      this.setState({ image })
    }
  }

  submitForm = () => {

    let form = this.form.getForm()
    this.props.setData(form, () => {

      this.postValue()

    })
  }

  postValue = () => {
    // console.log("postValue")
    if (this.form) {
      let data = this.props.initData



      this.setState({ errors: null })
      let page = this.props.page

      if (data) {
        let isEditing = data._id ? true : false
        let address = isEditing ? (page.editUrl ?? page.addUrl) : page.addUrl
        data.page = this.props.page?.key
        this.setState({ isPostingData: true })

        if (page.postBody) {
          data = { ...data, ...page.postBody }
        }

        for (const [key, value] of Object.entries(data)) {
          if (/\{\{(.*?)\}\}/.test(value)) {

            if (this.props.variables) {
              data[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
            }
          }
        }

        // console.log(address)
        // console.log(data)


        HttpServices.request(address, data, (fetchResult, fetchError, fetchStatus) => {
          this.setState({ isPostingData: false })

          // console.log(fetchError)
          if (fetchError) {
            this.setState({ errors: fetchError.errors })
            this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message })
            return
          }
          if (fetchResult) {
            this.props.closeSidebar()
          }

          this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postDataSuccesfully', description: '{{lang}}info.dataUpdatedSuccessfully' })
          if (!isEditing) {
            this.props.userInvited(fetchResult.info)
          }

          if (isEditing) {
            // console.log("itemEdited")
            // console.log(data)
            if (fetchResult.info) {
              this.props.itemEdited(fetchResult.info, data._id)
            } else {
              this.props.itemEdited(data, data._id)
            }
          }
        })
      }

    }
  }

  hideModal = () => {
    this.props.hideModal()
  }




  render() {
    // console.log(this.props.initData)
    return (
      <div className="pb-3" style={{}}>
        <div className='flexcb  position-sticky top-0 w-100' style={{ padding: '8px 14px', backgroundColor: '#fff', zIndex: 2, borderBottom: '1px solid #eee', }}>
          <div className='flexc' style={{}}>
            {!this.props.edit && (
              <button onClick={() => this.props.changePage('search')}>
                <img width={18} className='mrd-2 flexcc invert' src='/assets/icons/arrow-left-white.svg' alt="" />
              </button>
            )}
            <p className='text-normal text-semibold' >{translate('Hub info')}</p>
          </div>
          <div className="flexc">
            <div className="prd-2">
              <ButtonAnimated
                iconwidth='24px'
                onClick={() => this.props.changePage('home')}
                title={translate('Cancel')}
                // icon='/assets/icons/arrow-right-white.svg'
                textColor={'#777'}
                // invert={!this.props.colors?.iconInvert}
                bg={'#eee'}
              // isLoading={this.state[prop.loader]}
              />
            </div>
            <ButtonAnimated
              iconwidth='24px'
              onClick={this.state.isPostingData ? () => { } : () => this.submitForm()}
              title={translate('Submit')}
              icon='/assets/icons/arrow-right-white.svg'
              textColor={this.props.colors?.textColor ?? '#fff'}
              invert={this.props.colors?.iconInvert}
              bg={this.props.colors?.background ?? 'linear-gradient(90deg, rgb(88, 86, 214), rgb(124, 122, 255))'}
              isLoading={this.state.isPostingData}
            />
          </div>
        </div>
        {/* <div className="d-flex flex-column py-2  px-3 " style={{ borderRadius: '8px 8px 0px 0px', background: 'linear-gradient(to  left , #677dc4, #877cc4)', position: 'sticky', top: 0, zIndex: 1 }}>
          <p className="mt-1 text-big text-bold white">{translate("User Info")}</p>
        </div> */}

        {/* <div className="pt-3  px-3 text-smaller pb-2 flexcb" style={{ color: '#203040' }}>

          <UserIndicator data={this.props.initData?.hub} />

          {this.props.initData?.status && (
            <div >
              <StatusIndicator data={this.props.initData?.status} />
            </div>
          )}
        </div> */}

        <div className=" mt-4">

          <FormViewer ref={el => this.form = el} pages={this.props.page?.formPages} headers={this.props.headers} initData={this.props.initData} errors={this.state.errors} formClass={'bordered-form'} inputClass={'bordered-input'} variables={this.props.variables} />

          {/* <div className="w-100 flexc mt-4" style={{ justifyContent: 'space-around' }}>
            <button className="text-small py-2 px-3 white w-100 mrd-1 text-bold" style={{ background: 'linear-gradient(to  left , #009680, #007C81)', borderRadius: '20px' }}><p>{translate("invite")}</p></button>
            <button className="text-small py-2 px-3  w-100 mld-1" style={{ background: 'linear-gradient(to  left , #e2e8ea, #e8eaf0)', borderRadius: '20px' }}><p>{translate("Add more Info")}</p></button>
          </div> */}


          {/* <div className="flexc px-3 pb-3 mt-2">
            {Object.values(this.state.actions).map((prop, index) => {
              return (
                <div key={index} className="w-100 mx-1">

                  <LoaderButton
                    onClick={this[prop.function]}
                    isLoading={this.state[prop.loader]}
                    text={checkTranslation(prop.label)}
                    type={"Oval"}
                    className="text-bold text-small text-uppercase w-100"
                    buttonStyle={{ outline: 'none', width: '100%', backgroundColor: prop.bgColor, cursor: 'pointer', padding: '13px 20px', borderRadius: 8, textTransform: 'uppercase', fontSize: 15, fontWeight: 'bold', color: prop.color, border: 'none' }}
                    width={40}
                    height={40}
                    color={prop.bgColor}
                  />
                </div>
              )
            })}
          </div> */}

        </div>
        {/* {!this.props.edit && (
          <button onClick={() => this.props.lastStage()} className="text-small py-2 px-3 white w-100 mt-2 " style={{ color: '#789', borderRadius: '20px' }}><p>{translate("back one stage?")}</p></button>
        )} */}


      </div>

    );
  }
}



export default AddUserForm;
